import { Component } from '@angular/core';

@Component({
  selector: 'gc-empty-list-warning',
  templateUrl: './empty-list-warning.component.html',
  styleUrls: ['./empty-list-warning.component.scss'],
})
export class EmptyListWarningComponent {}
